import { useState, useEffect, useCallback } from "react";
import { getMonthlyReport } from "../../../../../api/reports/reports";
import { getAssociates }    from "../../../../../api/associates";
import { getMacsList }      from "../../../../../api/macs";

const currentDate = new Date();

export const useReportData = () => {
  const [year,  setYear]  = useState(currentDate.getFullYear());
  const [month, setMonth] = useState(currentDate.getMonth() + 1);

  const [selectedMacIds,       setSelectedMacIds]       = useState([]);
  const [selectedAssociateIds, setSelectedAssociateIds] = useState([]);
  const [selectedStatuses,     setSelectedStatuses]     = useState([]);
  const [selectedFteValues,    setSelectedFteValues]    = useState([]);

  const [macs,       setMacs]       = useState([]);
  const [associates, setAssociates] = useState([]);

  const [reportData, setReportData] = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState(null);

  useEffect(() => {
    getMacsList()
      .then((r) => setMacs(r.data || r || []))
      .catch(() => setMacs([]));
    getAssociates()
      .then((r) => setAssociates(r.data || r || []))
      .catch(() => setAssociates([]));
  }, []);

  const fetchReport = useCallback(() => {
    setLoading(true);
    setError(null);
    getMonthlyReport({
      year,
      month,
      macIds:       selectedMacIds,
      associateIds: selectedAssociateIds,
      statuses:     selectedStatuses,
      fteValues:    selectedFteValues,
    })
      .then((data) => setReportData(data))
      .catch((e)   => setError(e?.response?.data?.message || "Failed to load report"))
      .finally(()  => setLoading(false));
  }, [year, month, selectedMacIds, selectedAssociateIds, selectedStatuses, selectedFteValues]);

  

  const reset = () => {
    setSelectedMacIds([]);
    setSelectedAssociateIds([]);
    setSelectedStatuses([]);
    setSelectedFteValues([]);
  };

  const navigateMonth = (dir) => {
    let m = month + dir;
    let y = year;
    if (m < 1)  { m = 12; y -= 1; }
    if (m > 12) { m = 1;  y += 1; }
    setMonth(m);
    setYear(y);
  };

  return {
    year, month, navigateMonth,
    selectedMacIds,       setSelectedMacIds,
    selectedAssociateIds, setSelectedAssociateIds,
    selectedStatuses,     setSelectedStatuses,
    selectedFteValues,    setSelectedFteValues,
    macs, associates,
    fetchReport, reset,
    reportData, loading, error,
  };
};